<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <h2>Vorlagenübersicht</h2>
        <TabList class="tab-list" :items="items" :active-item-name="activeItemName"></TabList>
        <transition name="fade" mode="out-in">
            <div v-if="loading" :key="0" class="loader">
                <dot-loader id="loader"></dot-loader>
            </div>
            <div v-else :key="1">
                <div class="spaces-filter-container">
                    <div class="top-bar-left">
                        <InputSearch placeholder="Suche" v-model="searchValue"></InputSearch>
                        <Checkbox @change="onFilterChanged" v-model="checked['Online']" id="filter-in-progress"
                                  title="Online"></Checkbox>
                        <Checkbox @change="onFilterChanged" v-model="checked['Desktop']" id="filter-in-progress"
                                  title="Desktop"></Checkbox>
                        <Checkbox @change="onFilterChanged" v-model="checked['Mobile']" id="filter-checked"
                                  title="Mobile"></Checkbox>
                        <Checkbox @change="onFilterChanged" v-model="checked['Tablet']" id="filter-built-in"
                                  title="Tablet"></Checkbox>
                    </div>
                    <AdaButton title="NEUE VORLAGE" to="/templates/trackinglists/create" type="createButton"
                               icon="icon-add"></AdaButton>
                </div>
                <AdaDatatable class="listingTable" :columns="columns" :data="rows" :show-search="false"
                              :size-of-page="10"
                              @rowClicked="cellClicked" :search-value="searchValue" :table-filters="[tableFilter]"
                              :save-sort-state="true" table-id="tTrackingListTable"
                              :transformers="transformers">
                    <AdaButton style="width: 100%; height: 50px" title="NEUE VORLAGE ERSTELLEN" type="fullWidthButton"
                               to="/templates/trackinglists/create" icon="icon-add"></AdaButton>
                </AdaDatatable>
            </div>
        </transition>
        <Dialog v-if="trackingListToDelete" :show-close-button="true" :show="showDeleteTrackingListDialog"
                :has-backdrop="true"
                @close="deleteDialogClose">
            <div class="delete-container">
                <h4 style="margin-top:0">Module löschen</h4>
                <div style="margin-bottom: 30px">
                    Soll die Trackingliste: <span style="font-weight: bold">{{this.trackingListToDelete.name}}</span>
                    wirklich
                    gelöscht werden?
                </div>
                <AdaButton :loading="deletingTemplate" class="btn-delete" @click="deleteClicked" title="LÖSCHEN"
                           type="createButton"
                           style="width:fit-content"></AdaButton>
            </div>
        </Dialog>
        <Dialog v-if="tlToCopy" :show-close-button="true" :show="showCopyTlDialog"
                :has-backdrop="true"
                @close="copyDialogClose">
            <div class="delete-container">
                <h4 style="margin-top:0">Trackingliste kopieren</h4>
                <div style="margin-bottom: 30px">
                    Soll die Trackingliste: <span style="font-weight: bold">{{this.tlToCopy.name}}</span>
                    wirklich
                    kopiert werden?
                </div>
                <AdaButton :loading="copyingTemplate" class="btn-delete" @click="copyClicked" title="KOPIEREN"
                           type="createButton" style="width:fit-content"></AdaButton>
            </div>
        </Dialog>
    </div>
</template>

<script>

    import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
    import TabList from "../../../components/tablist/TabList";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import InputSearch from "../../../components/inputs/InputSearch";
    import AdaButton from "../../../components/buttons/AdaButton";
    import Transformers from "../../../components/tables/Transformers";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import Dialog from "../../../components/dialog/Dialog";
    import Checkbox from "../../../components/inputs/Checkbox";

    const TrackingListsRepository = RepositoryFactory.get('trackingLists');

    export default {
        components: {
            TabList,
            BreadCrumb,
            AdaDatatable,
            InputSearch,
            AdaButton,
            Dialog,
            Checkbox
        },
        data: function () {
            return {
                tableFilter: {
                    propName: 'target_medium',
                    allowedValues: []
                },
                checked: {
                    "Online": false,
                    "Desktop": false,
                    "Mobile": false,
                    "Tablet": false
                },
                tlToCopy: null,
                showCopyTlDialog: false,
                trackingListToDelete: null,
                showDeleteTrackingListDialog: false,
                searchValue: '',
                columns: [
                    {
                        viewName: 'AdSpecial',
                        propName: 'name',
                        sortable: true,
                        width: '45%'
                    },
                    {
                        viewName: 'Erstellungsdatum',
                        propName: 'created_at',
                        sortable: true,
                        width: '20%'
                    },
                    {
                        viewName: 'Medium',
                        propName: 'target_medium',
                        width: '20%'
                    },
                    {
                        viewName: 'Aktion',
                        propName: 'action',
                        width: '15%'
                    }
                ],
                rows: [],
                items: [
                    {
                        name: 'Tracking-Listen',
                        link: '/templates/trackinglists'
                    },
                    {
                        name: 'Spaces',
                        link: '/templates/spaces'
                    },
                    {
                        name: 'Module',
                        link: '/templates/modules'
                    },
                    {
                        name: 'Interaktionen',
                        link: '/templates/interactions'
                    }
                ],
                activeItemName: 'Tracking-Listen',
                transformers: [
                    {
                        propName: 'action',
                        transform: function (value) {
                            let res = '';
                            value.forEach(action => {
                                switch (action) {
                                    case 'edit':
                                        res += '<span data-type="edit" class="margin-right hover-highlight icon icon-edit"></span>';
                                        break;
                                    case 'copy':
                                        res += '<span data-type="duplicate" class="margin-right hover-highlight icon icon-duplicate"></span>';
                                        break;
                                    case 'delete':
                                        res += '<span data-type="delete" class="margin-right hover-highlight icon icon-delete"></span>';
                                        break;
                                }
                            });
                            return res;
                        }
                    },
                    {
                        propName: 'created_at',
                        transform: Transformers.dateTransformer
                    },
                    {
                        propName: 'target_medium',
                        transform: function (value) {
                            let res = '';
                            switch (value.toLowerCase()) {
                                case 'online':
                                    res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-xdigital"></span>';
                                    break;
                                case 'desktop':
                                    res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-desktop"></span>';
                                    break;
                                case 'mobile':
                                    res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-mobile"></span>';
                                    break;
                                case 'tablet':
                                    res += '<span style="color: rgb(215,4,101);font-size: 2.2em;" class="margin-right hover-highlight icon-device-tablet"></span>';
                                    break;
                            }
                            return res;
                        }
                    }
                ],
                loading: true,
                copyingTemplate: false,
                deletingTemplate: false,
            }
        },
        name: "TemplateTrackingLists",
        mounted() {
            this.fetchTrackingLists();
        },
        methods: {
            async fetchCopyTl() {
                try {
                    await TrackingListsRepository.copyTrackingList(this.tlToCopy.id);
                    this.$noty.success('Trackingliste erfolgreich kopiert.');
                    this.tlToCopy = null;
                    this.loading = true;
                    this.fetchTrackingLists();
                } catch (e) {
                    console.error(e);
                    this.$noty.error('Trackingliste konnte nicht kopiert werden: ' + e);
                }
                this.copyingTemplate = false;
                this.showCopyTlDialog = false;
            },
            copyClicked() {
                this.copyingTemplate = true;
                this.fetchCopyTl();
            },
            copyDialogClose() {
                this.showCopyTlDialog = false;
            },
            onFilterChanged: function () {
                this.runFilter();
            },
            runFilter: function () {
                let allowedValues = [];
                for (let key in this.checked) {
                    if (this.checked[key]) {
                        allowedValues.push(key);
                    }
                }
                this.tableFilter.allowedValues = allowedValues;
            },
            deleteDialogClose: function () {
                this.showDeleteTrackingListDialog = false;
                this.trackingListToDelete = null;
            },
            deleteClicked() {
                this.deletingTemplate = true;
                this.deleteTrackingListTemplate(this.trackingListToDelete.id);
            },
            cellClicked: function (data) {
                let dataType = data.target.getAttribute('data-type');
                switch (dataType) {
                    case 'edit':
                        this.$router.push({name: 'edittrackinglisttemplate', params: {id: data.row.id}});
                        break;
                    case 'duplicate':
                        this.tlToCopy = data.row;
                        this.showCopyTlDialog = true;
                        break;
                    case 'delete':
                        this.showDeleteTrackingListDialog = true;
                        this.trackingListToDelete = data.row;
                        break;
                    case 'dashboard':
                        this.$router.push({name: 'showDashboard', params: {id: data.row.id}});
                        break;
                    default:
                        this.$router.push({name: 'edittrackinglisttemplate', params: {id: data.row.id}});
                        break;
                }
            },
            async fetchTrackingLists() {
                const {data} = await TrackingListsRepository.getTrackingListTemplates();
                data.forEach(space => {
                    space.action = [
                        'edit',
                        'copy',
                        'delete'
                    ];
                });
                this.rows = data;
                this.loading = false;
            },
            async deleteTrackingListTemplate(id) {
                try {
                    await TrackingListsRepository.deleteTrackingList(id);
                    this.$noty.success("Die Trackingliste wurde erfolgreich gelöscht.");
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler beim Löschen der Trackingliste.");
                }
                this.deletingTemplate = false;
                this.showDeleteTrackingListDialog = false;
                this.fetchTrackingLists();
                this.loading = true;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .spaces-filter-container {
        width: 100%;
        background-color: white;
        height: 50px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 12px;
    }

    .tab-list {
        margin-bottom: 20px;
    }

    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        width: 100%;
    }

    ::v-deep tbody tr td:nth-child(3) {
        padding: 0 20px;

        span[class*='icon-']:before {
            top: 4px;
            position: relative;
        }
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }
</style>